export default class Region {
	constructor(
		public name: string,
		public trendingShots: number,
		public trendingTime: string,
		public totalShotsInRegion: number
	) {}
}
